var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52713 5.62012C3.81826 5.62012 4.05426 5.85612 4.05426 6.14725L4.05426 11.9457L9.85272 11.9457C10.1438 11.9457 10.3799 12.1817 10.3799 12.4728C10.3799 12.7639 10.1438 13 9.85272 13L3.52713 13C3.23601 13 3 12.7639 3 12.4728L3 6.14725C3 5.85612 3.23601 5.62012 3.52713 5.62012Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8456 3.15439C13.0515 3.36025 13.0515 3.69401 12.8456 3.89987L3.89987 12.8457C3.69401 13.0515 3.36025 13.0515 3.15439 12.8457C2.94854 12.6398 2.94854 12.306 3.15439 12.1002L12.1002 3.15439C12.306 2.94854 12.6397 2.94854 12.8456 3.15439Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomLeft);
export default __webpack_public_path__ + "static/media/_arrow-bottom-left.b48b0746fe6ddcacc4ec23b1f8e20075.svg";
export { ForwardRef as ReactComponent };